module.exports = __webpack_public_path__ + "img/counter-bg.d6d623da.png";